import {
  formatDate,
  FormStyle,
  getLocaleDayNames,
  getLocaleMonthNames,
  TranslationWidth
} from '@angular/common'
import { Injectable, OnDestroy } from '@angular/core'
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'
import { LanguageService } from '@spartacus/core'
import { Subscription } from 'rxjs'

@Injectable()
export class EbDatePickerI18nService extends NgbDatepickerI18n implements OnDestroy {
  private _monthsShort: readonly string[]
  private _monthsFull: readonly string[]
  private _weekdaysShort: readonly string[]
  private locale: string
  private readonly subscriptions = new Subscription()

  constructor(languageService: LanguageService) {
    super()
    languageService.getActive().subscribe(locale => {
      this.locale = locale
      this.fetchLocalizations()
    })
  }

  getWeekdayShortName(weekday: number): string {
    return this._weekdaysShort[weekday - 1] || ''
  }

  getWeekdayLabel(weekday: number, width?: 'long' | 'short' | undefined): string {
    const weekdaysStartingOnSunday = [...Array(7).keys()].map(v =>
      new Date(Date.UTC(1970, 0, 4 + v)).toLocaleDateString(this.locale, {
        weekday: width === undefined ? 'short' : width
      })
    )
    const weekdays = weekdaysStartingOnSunday.map(
      (day, index) => weekdaysStartingOnSunday[(index + 1) % 7]
    )
    return weekdays[weekday - 1] || ''
  }

  getMonthShortName(month: number): string {
    return this._monthsShort[month - 1] || ''
  }

  getMonthFullName(month: number): string {
    return this._monthsFull[month - 1] || ''
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    const jsDate = new Date(date.year, date.month - 1, date.day)
    return formatDate(jsDate, 'fullDate', this.locale)
  }

  fetchLocalizations() {
    const weekdaysStartingOnSunday = getLocaleDayNames(
      this.locale,
      FormStyle.Standalone,
      TranslationWidth.Short
    )
    this._weekdaysShort = weekdaysStartingOnSunday.map(
      (day, index) => weekdaysStartingOnSunday[(index + 1) % 7]
    )
    this._monthsShort = getLocaleMonthNames(
      this.locale,
      FormStyle.Standalone,
      TranslationWidth.Abbreviated
    )
    this._monthsFull = getLocaleMonthNames(this.locale, FormStyle.Standalone, TranslationWidth.Wide)
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe()
  }
}
